import { PureFunctional, React } from '../../../../react';
import { INoteChat, IParticipant } from '../../../../types';
import DataItemNoteChat from '../dataitemchat';
import { notechatResource } from '../../resource';

import cx from '../datalistchat/style.less';

interface IDataListPropsNoteChat {
    items: INoteChat[];
    participants: IParticipant[];
    noteId: number;
    visible?: boolean;
    flyoverVisible?: boolean;
}

export const DataListChat = PureFunctional<IDataListPropsNoteChat>('DataListChat')(
    ({ items, participants, noteId, flyoverVisible }) => {

        return (
            <div className={cx('data-list-chat', flyoverVisible? 'flyover-chat-list': 'modal-chat-list')}>
                <ul className={cx('data-list-chat-container')} tabIndex={-1}>
                        {items.qWhere((itm)=> itm.noteId===noteId && !itm.attached)
                            .sort((a: INoteChat, b: INoteChat)=> a.created < b.created ? 1 : -1 )
                            .qSelect((item: INoteChat) => (
                                <DataItemNoteChat
                                    key={notechatResource.fields.key(item).toString()}
                                    flyoverVisible={flyoverVisible}
                                    item={item as INoteChat} 
                                    participant={participants.qWhere((i)=>i.id===item.userId).qFirst()} />

                        ),
                    )}
                </ul>
            </div>
        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notechat/notechatdatalist/datalistchat/index.tsx